import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef } from 'react';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { usePropsValue } from '../../utils/use-props-value';
import { Star } from './star';
import { useDrag } from '@use-gesture/react';
import { bound } from '../../utils/bound';
var classPrefix = "adm-rate";
var defaultProps = {
  count: 5,
  allowHalf: false,
  character: React.createElement(Star, null),
  defaultValue: 0,
  readOnly: false,
  allowClear: true
};
export var Rate = function Rate(p) {
  var props = mergeProps(defaultProps, p);

  var _usePropsValue = usePropsValue(props),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      value = _usePropsValue2[0],
      setValue = _usePropsValue2[1];

  var containerRef = useRef(null);
  var starList = Array(props.count).fill(null);

  function renderStar(v, half) {
    var _classNames;

    return React.createElement("div", {
      className: classNames("".concat(classPrefix, "-star"), (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-star-active"), value >= v), _defineProperty(_classNames, "".concat(classPrefix, "-star-half"), half), _defineProperty(_classNames, "".concat(classPrefix, "-star-readonly"), props.readOnly), _classNames)),
      role: 'radio',
      "aria-checked": value >= v,
      "aria-label": '' + v
    }, props.character);
  }

  var bind = useDrag(function (state) {
    if (props.readOnly) return;

    var _state$xy = _slicedToArray(state.xy, 1),
        clientX = _state$xy[0],
        tap = state.tap;

    var container = containerRef.current;
    if (!container) return;
    var rect = container.getBoundingClientRect();
    var rawValue = (clientX - rect.left) / rect.width * props.count;
    var ceiledValue = props.allowHalf ? Math.ceil(rawValue * 2) / 2 : Math.ceil(rawValue);
    var boundValue = bound(ceiledValue, 0, props.count);

    if (tap) {
      if (props.allowClear && boundValue === value) {
        setValue(0);
        return;
      }
    }

    setValue(boundValue);
  }, {
    axis: 'x',
    pointer: {
      touch: true
    },
    filterTaps: true
  });
  return withNativeProps(props, React.createElement("div", Object.assign({
    className: classPrefix,
    role: 'radiogroup',
    "aria-readonly": props.readOnly,
    ref: containerRef
  }, bind()), starList.map(function (_, i) {
    return React.createElement("div", {
      key: i,
      className: classNames("".concat(classPrefix, "-box"))
    }, props.allowHalf && renderStar(i + 0.5, true), renderStar(i + 1, false));
  })));
};